
const closeButtonWebviewMessenger = (window) => {
  const sendCloseMessage = () => window.ReactNativeWebView.postMessage('CloseButtonClicked');
  const closeButton = window.document.querySelectorAll('.btn-close, .map-back-button');
  const isWebview = window.isWebview;

  if (isWebview) {
    closeButton.forEach(element => {
      element.addEventListener('click', sendCloseMessage);
    });
  }
};

export default closeButtonWebviewMessenger;
